var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningSvg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.47012 18.0036H17.5301C19.0701 18.0036 20.0301 16.3336 19.2601 15.0036L11.7301 1.99359C10.9601 0.663594 9.04012 0.663594 8.27012 1.99359L0.740121 15.0036C-0.0298787 16.3336 0.930121 18.0036 2.47012 18.0036ZM10.0001 11.0036C9.45012 11.0036 9.00012 10.5536 9.00012 10.0036V8.00359C9.00012 7.45359 9.45012 7.00359 10.0001 7.00359C10.5501 7.00359 11.0001 7.45359 11.0001 8.00359V10.0036C11.0001 10.5536 10.5501 11.0036 10.0001 11.0036ZM11.0001 15.0036H9.00012V13.0036H11.0001V15.0036Z",
    fill: "#C8822E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSvg3);
export default __webpack_public_path__ + "static/media/WarningSVG3.2e0f0c4c202e486dc90d8ddcb06b944e.svg";
export { ForwardRef as ReactComponent };